import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {Button, Input, Screen, Select} from '../components';
import { fetchApps, cleanApps, setUser } from '../actions';
import {__, formatAmount, isEmptyString, isValidZip, request, toNumber} from '../functions';
import '../assets/styles/apps-screen.css';
import {IconButton, Tooltip} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {MARKET} from "../config";

/**
 * Apps.
 */
class AppsScreen extends Screen {
    /**
     * Title.
     *
     * @type {string}
     */
    title = __('Služby');

    /**
     * Default state.
     *
     * @type {Object}
     */
    state = {
        lightbox: {
            hours: false,
        },
    };

    /**
     * Komponenta bola pripojena.
     *
     * @return boolean
     */
    async componentDidMount() {
        if (super.componentDidMount()) {
            const { fetchApps } = this.props;

            // Nacitame zamestnanca
            await fetchApps(this);
        }

        return true;
    }

    /**
     * Komponenta bude odpojena.
     */
    componentWillUnmount() {
        const { cleanApps } = this.props;

        cleanApps();
    }

    onClickLink(link) {
        navigator.clipboard.writeText(link);

        this.showSnackbar('success', __('Skopirované do schránky'));
    }

    confirmHours(hours) {
        const { apps } = this.props;

        let settings = apps.settings.invoicing;

        if (!_.has(settings, 'country')) {
            // Nema krajinu
            settings = { ...settings, country: MARKET };
        }

        this.showLightbox('hours', { loading: false, hours, settings });
    }

    onChangeHours(key, value) {
        const { lightbox } = this.state;

        this.setState({ lightbox: { ...lightbox, hours: {
            ...lightbox.hours,
            settings: { ...lightbox.hours.settings, [key]: value }
        } } });
    }

    createHoursInvoice() {
        const { lightbox } = this.state;

        let error = '';

        if (isEmptyString(lightbox.hours.settings.name)) {
            // Nie je vyplneny nazov
            error = __('Nie je vyplnený názov');
        } else if (isEmptyString(lightbox.hours.settings.address)) {
            // Nie je vyplnena adresa
            error = __('Nie je vyplnená adresa');
        } else if (isEmptyString(lightbox.hours.settings.city)) {
            // Nie je vyplnene mesto
            error = __('Nie je vyplnené mesto');
        } else if (!isValidZip(lightbox.hours.settings.zip)) {
            // Neplatne PSC
            error = __('Neplatné PSČ');
        }

        if (error !== '') {
            this.showSnackbar('error', error);
            return null;
        }

        this.setState({ lightbox: { ...lightbox, hours: {...lightbox.hours, loading: true } } });

        request(`/subscriptions/createHoursProforma/${lightbox.hours.hours}`, { settings: lightbox.hours.settings }, 'POST').then(response => {
            const { status, data } = response.data;

            if (status === 'error') {
                // Nepodarilo sa generovat
                this.showSnackbar('error', __('Nepodarilo sa vygenerovať faktúru'));
                this.setState({ lightbox: { ...lightbox, hours: {...lightbox.hours, loading: false } } });
                return;
            }

            // Stiahneme fakturu
            request(`/subscriptions/pdf/${data.id}`).then(response => {
                const { status, data } = response.data;

                if (status === 'error') {
                    // Nepodarilo sa stiahnut pdf
                    this.showSnackbar('error', __('Nepodarilo sa stiahnuť pdf'));
                    this.setState({ lightbox: { ...lightbox, hours: {...lightbox.hours, loading: false } } });
                    return;
                }

                // Stiahneme subor
                window.location = data.link;

                this.showSnackbar('success', __('Faktúra bola stiahnutá'));

                this.closeLightbox('hours');
            });
        });
    }

    renderHours() {
        const { apps } = this.props;

        const disabled = this.isDemo() || _.isEmpty(apps.settings);

        return (
            <div className="apps-screen__window">
                <div className="apps-screen__window__title">
                    <div className="apps-screen__window__title__text">{__('Programátorská podpora pre váš e-shop vždy, keď ju potrebujete')}</div>
                    <div className="apps-screen__window__title__hours-remaining">
                        <div className="apps-screen__window__title__hours-remaining__name">{__('Počet predplatených hodin')}:</div>
                        <div className="apps-screen__window__title__hours-remaining__value">{apps.it_hours_remaining}</div>
                    </div>
                </div>
                <div className="apps-screen__window__text">
                    <div>{__('Vďaka predplateným hodinám od našich skúsených programátorov získate istotu, že vaše požiadavky budú vyriešené rýchlo a efektívne – bez zbytočného čakania a zdĺhavých procesov.')}</div>
                    <div className="apps-screen__window__text__point">💰 {__('Výhodnejšia cena – čím viac hodín, tým nižšia hodinová sadzba')}</div>
                    <div className="apps-screen__window__text__point">🔧 {__('Flexibilita – hodiny môžete využiť na akékoľvek úpravy alebo nové integrácie')}</div>
                    <div className="apps-screen__window__text__point">📈 {__('Podpora rastu – pomôžeme vám prispôsobiť e-shop podľa aktuálnych potrieb trhu')}</div>
                </div>
                <div className="apps-screen__window__hours">
                    {_.map(apps.it_hours, (price, hours) => {
                        let info = null;

                        switch (toNumber(hours)) {
                            case 20:
                                info = __('Príklad: menšie úpravy v GoodEshop alebo vo vašom eshope na mieru.');
                                break;

                            case 50:
                                info = __('Príklad: napojenie GoodEshop na vaše interné systémy. Nové procesy, exporty.');
                                break;

                            case 100:
                                info = __('Príklad: aktualizácia skladov medzi vašimi eshopmi, internými systémami, dodávateľskými XML feedmi.');
                                break;

                            case 200:
                                info = __('Príklad: väčšie úpravy na mieru. Vypracovanie nových externých systémov pre váš eshop.');
                                break;

                            case 500:
                                info = __('Príklad: komplexnejšie úlohy a systémy na mieru.');
                                break;
                        }

                        return (
                            <div className="apps-screen__window__hours__hour" key={hours}>
                                <div className="apps-screen__window__hours__hour__name">{hours} {__('hodín')}</div>
                                <div className="apps-screen__window__hours__hour__info">{info}</div>
                                <div className="apps-screen__window__hours__hour__price">{formatAmount(price, 'EUR')}</div>
                                <div className="apps-screen__window__hours__hour__text">{__('Cena za 1 hod')}: {formatAmount(price / hours, 'EUR')}</div>
                                <Button
                                    onClick={() => this.confirmHours(hours)}
                                    color="primary"
                                    disabled={disabled}
                                >{__('Objednať')}</Button>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderAffiliate() {
        const { apps } = this.props;

        let link = `https://goodeshop.${MARKET}?source=${apps.affiliate_name}`;

        if (this.isDemo()) {
            link = `https://goodeshop.${MARKET}`;
        }

        return (
            <div className="apps-screen__window">
                <div className="apps-screen__window__title">
                    <div className="apps-screen__window__title__text">{__('Odporučte nás a získajte odmenu!')}</div>
                </div>
                <div className="apps-screen__window__text">
                    <div>{__('Máte známeho s e-shopom, ktorý potrebuje kvalitné prepojenia a technickú podporu?')}</div>
                    <div className="apps-screen__window__text__point">💰 {__('Pošlite mu svoj unikátny odkaz. Keď sa zaregistruje a zaplatí, odmeníme vás zľavou 20 % z jeho platby, ktorú môžete využiť na nákup členstva alebo ďalších služieb.')}</div>
                </div>
                <div className="apps-screen__window__affiliate">
                    <div className="apps-screen__window__affiliate__link">
                        <div className="apps-screen__window__affiliate__link__text">{__('Váš unikátny odkaz')}:</div>
                        <div className="apps-screen__window__affiliate__link__url">{link}</div>
                        <Tooltip title={__('Skopírovať')}>
                            <span>
                                <IconButton onClick={() => this.onClickLink(link)}>
                                    <ContentCopyIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </div>
                    <div className="apps-screen__window__affiliate__stats">
                        <div className="apps-screen__window__affiliate__stats__stat">
                            <div className="apps-screen__window__affiliate__stats__stat__name">{__('Užívatelia')}</div>
                            <div className="apps-screen__window__affiliate__stats__stat__value">{apps.affiliate_users}</div>
                        </div>
                        <div className="apps-screen__window__affiliate__stats__stat">
                            <div className="apps-screen__window__affiliate__stats__stat__name">{__('Eshopy')}</div>
                            <div className="apps-screen__window__affiliate__stats__stat__value">{apps.affiliate_eshops}</div>
                        </div>
                        <div className="apps-screen__window__affiliate__stats__stat">
                            <div className="apps-screen__window__affiliate__stats__stat__name">{__('Vaša zľava')}</div>
                            <div className="apps-screen__window__affiliate__stats__stat__value">{formatAmount(apps.affiliate_discount, 'EUR')}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderAi() {
        return (
            <div className="apps-screen__window">
                <div className="apps-screen__window__title">
                    <div className="apps-screen__window__title__text">{__('AI - Vylepšite svoj e-shop pomocou umelej inteligencie')}</div>
                </div>
                <div className="apps-screen__window__text">
                    <div>{__('Ponúkame vám naprogramovanie nových funkcionalít na mieru, ktoré využívajú silu umelej inteligencie priamo vo vašom e-shope alebo v GoodEshop.')}</div>
                    <div className="apps-screen__window__text__point">{__('Od automatizovaných odporúčaní produktov, cez inteligentné spracovanie objednávok až po analýzu zákazníckeho správania – všetko na mieru podľa vašich potrieb.')}</div>
                    <div className="apps-screen__window__text__point">🤖 {__('Automatizácia opakovaných úloh. Šetrite čas – AI zvládne rutiny za vás.')}</div>
                    <div className="apps-screen__window__text__point">🔍 {__('Lepšie rozhodovanie vďaka dátam. Získajte odporúčania na základe správania zákazníkov a histórie nákupov.')}</div>
                    <div className="apps-screen__window__text__point">🛍️ {__('Inteligentné odporúčanie produktov. Zvýšte priemernú hodnotu objednávky pomocou personalizovaných návrhov.')}</div>
                    <div className="apps-screen__window__text__point">📦 {__('Predikcia dopytu a optimalizácia skladu. AI vie predpovedať, čo sa bude predávať – a kedy.')}</div>
                </div>
                <Button
                    onClick={() => window.location = 'mailto:info@goodeshop.sk'}
                    color="green"
                >{__('Kontaktovať')}</Button>
            </div>
        );
    }

    renderMigrations() {
        return (
            <div className="apps-screen__window">
                <div className="apps-screen__window__title">
                    <div className="apps-screen__window__title__text">{__('Bezstarostná migrácia dát na kľúč')}</div>
                </div>
                <div className="apps-screen__window__text">
                    <div>{__('Plánujete prechod na nový e-shopový systém, CRM alebo iný nástroj?')}</div>
                    <div className="apps-screen__window__text__point">{__('Nechajte migráciu dát na nás. Zabezpečíme bezpečný, rýchly a kompletný prenos vašich dát – bez výpadkov, bez chaosu, bez chýb.')}</div>
                    <div className="apps-screen__window__text__point">🔧 {__('Zlučovanie viacerých e-shopov alebo systémov do jedného')}</div>
                    <div className="apps-screen__window__text__point">🛍️ {__('Produkty, kategórie, obrázky')}</div>
                    <div className="apps-screen__window__text__point">👥 {__('Zákaznícke účty a údaje')}</div>
                    <div className="apps-screen__window__text__point">📦 {__('Objednávky a faktúry')}</div>
                    <div className="apps-screen__window__text__point">🗃️ {__('História predaja, štatistiky, skladové zásoby')}</div>
                    <div className="apps-screen__window__text__point">🔗 {__('Pripojenia k externým službám a systémom')}</div>
                </div>
                <Button
                    onClick={() => window.location = 'mailto:info@goodeshop.sk'}
                    color="green"
                >{__('Kontaktovať')}</Button>
            </div>
        );
    }

    /**
     * Rendrovanie.
     *
     * @returns {JSX.Element}
     */
    render() {
        const { apps } = this.props;
        const { lightbox } = this.state;

        if (_.isEmpty(apps)) {
            return this.renderLoading();
        }

        if (!this.hasPermission('apps')) {
            return null;
        }

        return (
            <div className="apps-screen">
                {this.renderAffiliate()}
                {this.renderHours()}
                <div className="apps-screen__panels">
                    <div className="apps-screen__panels__panel">
                        {this.renderAi()}
                    </div>
                    <div className="apps-screen__panels__panel">
                        {this.renderMigrations()}
                    </div>
                </div>
                {this.renderLightbox(
                    'hours',
                    !_.isEmpty(lightbox.hours) ? `${__('Objednávka')} - ${lightbox.hours.hours} ${__('hodín')}` : '',
                    !_.isEmpty(lightbox.hours) ? <div className="apps_hours-lightbox">
                        <div className="apps_hours-lightbox__title">{__('Fakturačné údaje')}</div>
                        <div className="apps_hours-lightbox__panels">
                            <div className="apps_hours-lightbox__panels__panel">
                                <Input
                                    label={__('Adresa')}
                                    value={lightbox.hours.settings.address}
                                    onChange={value => this.onChangeHours('address', value)}
                                />
                                <Input
                                    label={__('Mesto')}
                                    value={lightbox.hours.settings.city}
                                    onChange={value => this.onChangeHours('city', value)}
                                />
                                <Input
                                    label={__('PSČ')}
                                    value={lightbox.hours.settings.zip}
                                    onChange={value => this.onChangeHours('zip', value)}
                                />
                                <Select
                                    label={__('Krajina')}
                                    value={lightbox.hours.settings.country}
                                    options={{ sk: 'sk', cz: 'cz', pl: 'pl', hu: 'hu' }}
                                    onChange={value => this.onChangeHours('country', value)}
                                    allowEmpty={false}
                                />
                            </div>
                            <div className="apps_hours-lightbox__panels__panel">
                                <Input
                                    label={__('Názov')}
                                    value={lightbox.hours.settings.name}
                                    onChange={value => this.onChangeHours('name', value)}
                                />
                                <Input
                                    label={__('IČO')}
                                    value={lightbox.hours.settings.ico}
                                    onChange={value => this.onChangeHours('ico', value)}
                                />
                                <Input
                                    label={__('DIČ')}
                                    value={lightbox.hours.settings.dic}
                                    onChange={value => this.onChangeHours('dic', value)}
                                />
                                {lightbox.hours.settings.country === 'sk' ? <Input
                                    label={__('IČ DPH')}
                                    value={lightbox.hours.settings.ic_dph}
                                    onChange={value => this.onChangeHours('ic_dph', value)}
                                /> : null}
                            </div>
                        </div>
                        <Button
                            onClick={() => this.createHoursInvoice()}
                            color="green"
                            loading={lightbox.hours.loading}
                        >{__('Vygenerovať faktúru')}</Button>
                    </div> : null,
                    '',
                    __('Zrušiť'),
                    () => {}
                )}
                {this.renderSnackbar()}
            </div>
        );
    }
}

const stateToProps = ({ apps, user }) => ({ apps, user });

export default withCookies(connect(stateToProps, {
    fetchApps,
    setUser,
    cleanApps,
})(AppsScreen));
